import React, { FC } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps } from "react-router";
import CustomFieldList from "go-component/components/CustomField/CustomFieldList";
import { selectOrganization } from "go-security/services/organizations/selectors";

const OrganizationSettingsCustomFieldsIndexPage: FC<RouteComponentProps> = (props) => {
	const organization = useSelector(selectOrganization);
	const taxIdNo = organization?.more?.print_company_on_pdf ? organization.more?.company_tax_id_no : undefined;
	const companyName = organization?.more?.print_company_on_pdf ? organization.more?.company_name : undefined;
	const pdfOrientation = organization?.more?.pdf_orientation;
	const pdfFontSize = organization?.more?.default_pdf_font_size?.toString();

	return (
		<CustomFieldList
			organization_name={organization.name ? organization.name : ""}
			routeProps={props}
			taxIdNo={taxIdNo}
			companyName={companyName}
			pdfFontSize={pdfFontSize}
			pdfOrientation={pdfOrientation}
		/>
	);
};
export default OrganizationSettingsCustomFieldsIndexPage;
